import { gql } from "@apollo/client";
import {
  PaginatedListMetaNoNestingFragment,
  RetailerPayTypeNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import { RetailerPayType as RetailerPayTypeEntity } from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import { listOptions, listVariables } from "../constants";
import { EntityResourceDefinition } from "../entity-resource-definition";
import { pageQuery } from "../page-query";
import RetailerPayTypeModel from "../../data/model/RetailerPayType";

const query = gql`
${RetailerPayTypeNoNestingFragment}
${PaginatedListMetaNoNestingFragment}
query GetRetailerPayTypes(${listVariables}) {
    retailerPayTypes(${listOptions}) {
        items {
          ...RetailerPayTypeNoNesting

        }
        meta {
          ...PaginatedListMetaNoNesting
        }
    }
}
`;

export const retailerPayTypeDefinition = new EntityResourceDefinition<
  RetailerPayTypeEntity,
  RetailerPayTypeModel
>({
  entity: "retailer_pay_types",
  query: query,
  prepareEntity: (newEntity, fetchedEntity) => {
    newEntity.payCode = fetchedEntity?.payCode || "";
    newEntity.payDescription = fetchedEntity.payDescription || "";
  },
  fetchEntities: (options) => {
    return pageQuery(client, "retailerPayTypes", query, options);
  },
});
